import React, { Component } from 'react';
import Header from '../components/AddRestaurantCover/Header';
import ContactFormMobile from '../components/AddRestaurantCover/ContactFormMobile';
import RestaurantCardPreview from '../components/AddRestaurantCover/RestaurantCardPreview';
import { withRouter } from 'react-router';
import { setDeviceToken } from '../services/notification_handler';

// Initial Landing Page
class AddRestaurantCover extends Component {
  
  constructor(){
    super();
    this.toggleAuthModal = this.toggleAuthModal.bind(this);
    this.setActiveForm = this.setActiveForm.bind(this);
    this.closeAuthModal = this.closeAuthModal.bind(this);
    this.toggleImageHover = this.toggleImageHover.bind(this);
    this.toggleRestaurantCardPreview = this.toggleRestaurantCardPreview.bind(this);
    this.closeRestaurantCardPreviewModal = this.closeRestaurantCardPreviewModal.bind(this);
    this.state = {
      authModalOpen: false,
      activeForm: "",
      isMobileScreen: false,
      restaurant: {},
      restaurantPreviewOpen: false,
      descriptionOverlayStyle: {display: 'none'}
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (localStorage.getItem("restaurant_id") === null){
      this.props.history.replace("/");
    } else {
      this.setState({
        restaurant: JSON.parse(localStorage.getItem("restaurant_details"))
      })
    }
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
    setDeviceToken();
  }

  updateDimensions() {
    let screen_width = window.innerWidth;
    if(screen_width < 500) {
        this.setState({ isMobileScreen: true });
    } else {
        this.setState({ isMobileScreen: false });
    }
  }

  preventDefault(e) {
    e.preventDefault();
  }

  preventDefaultForScrollKeys(e) {
    var keys = {9: 1, 38: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1};
    if (keys[e.keyCode]) {
      e.preventDefault();
      return false;
    }
  }

  disableScrolling(wheelOpt, wheelEvent) {
    window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
    window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }

  enableScrolling(wheelOpt, wheelEvent) {
    window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    window.removeEventListener(wheelEvent, this.preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', this.preventDefault, wheelOpt);
    window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
  }

  componentDidUpdate() {   
    try {
      var supportsPassive = false;
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; return(supportsPassive) } 
      }));
    } catch(e) {}
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    if(this.state.authModalOpen && !this.state.isMobileScreen){
      this.disableScrolling(wheelOpt, wheelEvent);
    } else {
      this.enableScrolling(wheelOpt, wheelEvent);
    }
  }

  componentWillUnmount(){
    try {
      var supportsPassive = false;
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; return(supportsPassive) } 
      }));
    } catch(e) {}
    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    this.enableScrolling(wheelOpt, wheelEvent);
  }

  toggleAuthModal() {
    this.setState({
      authModalOpen: true
    })
  }

  setActiveForm(form){
    if (this.state.activeForm !== form){
      this.setState({
        activeForm: form
      })
    }
  }

  closeAuthModal(){
    if (this.state.authModalOpen){
      this.setState({
        authModalOpen: false
      })
    }
  }

  toggleRestaurantCardPreview(restaurant){
    this.setState({
      restaurantPreviewOpen: true,
      restaurant: restaurant
    })
  }

  toggleImageHover(index){
    let dish = this.state.dish;
    if (dish.imageHover){
      this.setState({
        descriptionOverlayStyle: {display: 'none'}
      })
    } else {
      this.setState({
        descriptionOverlayStyle: {display: 'block'}
      })
    }
    dish.imageHover = !this.state.dish.imageHover;
    this.setState({
      dish: dish
    });
  }

  closeRestaurantCardPreviewModal(){
    this.setState({
      restaurantPreviewOpen: false
    })
  }

  render() {
    return (
      <div>
        <Header
          toggleAuthModal={this.toggleAuthModal}
          setActiveForm={this.setActiveForm}
          authModalOpen={this.state.authModalOpen}
          toggleRestaurantCardPreview={this.toggleRestaurantCardPreview}
          restaurant={this.state.restaurant}
        />
        <ContactFormMobile
          authModalOpen={this.state.authModalOpen}
          toggleRestaurantCardPreview={this.toggleRestaurantCardPreview}
        />
        <RestaurantCardPreview
          restaurantPreviewOpen={this.state.restaurantPreviewOpen}
          restaurant={this.state.restaurant}
          closeRestaurantCardPreviewModal={this.closeRestaurantCardPreviewModal}
        />
      </div>
    );
  }
}

export default withRouter(AddRestaurantCover);
